/*
 * @Author       : 萝卜兄台
 * @Date         : 2023-05-09 15:13:27
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2023-06-05 10:16:11
 * @FilePath     : \gas_station_platform_web\src\store\login.ts
 * @Description  : 这是描述
 */
/*
 * @name: 萝卜兄台
 * @Date: 2022-07-14 13:31:42
 * @LastEditors: ShiJie Xu shijie10086@163.com
 * @LastEditTime: 2023-02-13 01:06:13
 * @FilePath: \recognize_www\src\store\login.ts
 * @Description: login 
 */
import { defineStore } from 'pinia'
import { login, userInfo, updateUserInfo, fileUpload, updatePassword } from '@/api/login'
import { register } from '@/api/login'

export const loginStore = defineStore({
    id: 'login', // id必填，且需要唯一
    state: () => {
        return {
            toggle: 'login',
            loginLoading: false,
            userInfoData: [],
            sbLoading: false,
            fileLoading: false,
            upLoading: false
        }
    },
    actions: {
        getLogin({ payload, callback }: { payload: any, callback: any }) {
            this.loginLoading = true
            login(payload).then((res: any) => {
                localStorage.setItem('accessToken', res.data.accessToken)
                localStorage.setItem('refreshToken', res.data.refreshToken)
                localStorage.setItem('user', JSON.stringify(res.data.user))
                if (callback) {
                    callback(res.data)
                }
                this.loginLoading = false
            }).catch(() => {
                this.loginLoading = false
            })
        },
        getUserInfo({ callback }: { callback: any }) {
            userInfo().then((res: any) => {
                this.userInfoData = res.data
                if (callback) {
                    callback(res.data)
                }
            })
        },
        getUpdateUserInfo({ payload, callback }: { payload: any, callback: any }) {
            this.sbLoading = true
            updateUserInfo(payload).then((res: any) => {
                this.sbLoading = false
                if (callback) {
                    callback()
                }
            }).catch(() => {
                this.sbLoading = false
            })
        },
        getFileUpload({ payload, callback }: { payload: any, callback: any }) {
            this.fileLoading = true
            fileUpload(payload).then((res: any) => {
                this.fileLoading = false
                if (callback) {
                    callback(res.data)
                }
            }).catch(() => {
                this.fileLoading = false
            })
        },
        getUpdatePassword({ payload, callback }: { payload: any, callback: any }) {
            this.upLoading = true
            updatePassword(payload).then((res: any) => {
                this.upLoading = false
                if (callback) {
                    callback()
                }
            }).catch(() => {
                this.upLoading = false
            })
        },
        getRegister({ payload, callback }: { payload: any, callback: any }) {
            this.loginLoading = true
            register(payload).then((res: any) => {
                if (callback) {
                    callback(res.data)
                }
                this.loginLoading = false
            }).catch(() => {
                this.loginLoading = false
            })
        },
    }
})